import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth.service';
import { catchError, delay, of, switchMap, throwError } from 'rxjs';

const excludedEndpoints = [
  '/api/auth/send-password-recovery',
  '/api/auth/session',
  '/api/auth/sign-out',
];

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return of(null).pipe(delay(environment.local ? 1000 : 0), switchMap(() => next(request.clone({
    setHeaders: {
      'X-Tenant-Id': environment.firebaseConfig.tenantId,
    },
  })).pipe(catchError((error) => {
    const isExcluded = excludedEndpoints.some((endpoint) => request.url.startsWith(endpoint));
    if (error instanceof HttpErrorResponse && error.status === 401 && !isExcluded) {
      const returnUrl = router.url;
      authService.signOut();
      router.navigate(['/'], { queryParams: returnUrl === '/' ? undefined : { returnUrl } });
    }
    return throwError(() => error);
  }))));
};
